module.exports = __webpack_public_path__ + "img/log-out-icon.122e6401.svg";